import env from "react-dotenv";

export const API_BASE_URL = env.REACT_APP_API_URL;
export const GRAPHQL_URL = env.REACT_APP_GRAPHQL_URL || "http://localhost:8000/graphql";

